import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { LayoutComponent } from "../../shared/layout/layout.component";
import { BreadcrumbComponent } from "../../shared/breadcrumb/breadcrumb.component";
import { StepperComponent } from "../../shared/stepper/stepper.component";
import { TitleComponent } from "../../shared/title/title.component";
import { EnvelopeIconComponent } from "../../shared/icons/envelope/envelope.component";

@Component({
  selector: "app-register-email-sent",
  standalone: true,
  imports: [
    TranslatePipe,
    RouterLink,
    LayoutComponent,
    BreadcrumbComponent,
    StepperComponent,
    TitleComponent,
    EnvelopeIconComponent,
  ],
  templateUrl: "./register-email-sent.component.html",
  styleUrl: "./register-email-sent.component.css",
})
export class RegisterEmailSentComponent implements OnInit {
  email: string = "";

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.email = this.route.snapshot.queryParamMap.get("email") ?? "";
  }
}
